<template>
  <div class="title-container position-relative" :class="wrapperClassName" :style="{paddingTop: '0.2em', width: '100%'}">
    <div class="d-flex align-items-center gap-10">
      <div v-if="showBreadcrumbs" class="breadcrumbs-wrapper">
        <BootBread :customBreadcrumbs="breadcrumbs" />
      </div>
      <h3 class="title" :class="titleClassName">
        {{ pageTitle }}
      </h3>
      <slot name="onSideOfTitle" />
      <PageHeaderLoader v-if="pageLoading" />
    </div>
    <div class="title-container__controls">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
import PageHeaderLoader from '@components/common/PageHeaderLoader'
import BootBread from '@components/BootBread'

export default {
  name: 'PageHeader',
  components: {
    PageHeaderLoader, BootBread
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    titleClassName: {
      type: String
    },
    wrapperClassName: {
      type: String
    },
    tooltip: {
      type: String,
      default: ''
    },
    showBreadcrumbs: {
      type: Boolean,
      default: false
    },
    customBreadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    breadcrumbs () {
      return this.customBreadcrumbs
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs-wrapper {
  position: absolute;
  left: 0px;
  bottom: 100%;
  background: #F3F5F7;
  min-width: 100%;
}
</style>
